// extracted by mini-css-extract-plugin
module.exports = {"identifier":"i6yev0DovpB5v1LRAITgH","amount":"_3cFyxPHWwF98JmLwwlHPMq","list":"_2k1sHb7Eyvz2ayGhXHlsNR","item":"_18mMwe46kcl4DHVwO4h2DV"};